import colors from "../../../../../appConfig/colors";
import { makeStyles } from "@material-ui/core/styles";

const DashboardCategoryResultPopoverStyle = makeStyles(() => ({
	tooltip: {
		backgroundColor: "transparent",
		color: colors.black,
		boxShadow: "none",
		padding: 0,
		maxWidth: "none",
		pointerEvents: "auto",
	},
	arrow: {
		color: "transparent",
	},
	popoverContainer: {
		backgroundColor: colors.whiteSmoke,
		borderRadius: 8,
		padding: 16,
		boxSizing: "border-box",
		display: "flex",
		flexDirection: "column",
		border: `1px solid ${colors.black}`,
		width: "80vw",
		maxWidth: 700,
		minWidth: 300,
		maxHeight: "90vh",
		overflowY: "auto",
		overflowX: "hidden",
	},
	popoverHeader: {
		color: colors.white,
		background: colors.primary,
		padding: "4px",
		display: "inline-block",
	},
	maturityLevelContainer: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-around",
		flexWrap: "wrap",
		gap: 16,
		padding: "12px 16px",
		background: colors.veryPaleGray,
		boxShadow: `0 1px 4px ${colors.softShadowAlpha}`,
	},
	maturityLevelSubContainer: {
		display: "flex",
		alignItems: "center",
		gap: 8,
	},
	maturityLevelBanner: {
		width: 12,
		height: 12,
		borderRadius: "50%",
		display: "inline-block",
		backgroundColor: (props) => props.color,
	},
	maturityLevelText: {
		fontSize: 14,
		color: colors.charcoalGray,
		fontWeight: 500,
	},
	tableWrapper: {
		maxHeight: 300,
		overflowY: "auto",
		overflowX: "auto",
		boxShadow: `0 2px 6px ${colors.darkShadowAlpha}`,
		background: colors.white,
	},
	table: {
		width: "100%",
	},
	tableHeaderCell: {
		fontWeight: 700,
		fontSize: 12,
	},
	questionCell: {
		fontSize: 12,
		display: "flex",
	},
	typography: {
		paddingRight: 4,
	},
	scoreCell: {
		fontSize: 12,
		fontWeight: 600,
	},
	button: {
		marginTop: 15,
		color: colors.white,
		backgroundColor: colors.primary,
		textTransform: "none",
		"&:hover": {
			backgroundColor: colors.darkCrimsonRed,
		},
	},
	progressBar: {
		height: "100%",
		width: (props) => props.barLength,
		backgroundColor: (props) => props.color,
		transition: "width 0.5s ease",
		cursor: "pointer",
		float: (props) => props.float,
		"&:hover": {
			border: `1.5px solid ${colors.white}`,
			boxShadow: `0 4px 10px ${colors.whiteAlpha}`,
		},
	},
	tooltipBackground: {
		backgroundColor: "transparent",
	},
	centeredPopper: {
		position: "fixed !important",
		inset: "0 !important",
		top: "0 !important",
		left: "0 !important",
		transform: "none !important",
		display: "flex !important",
		alignItems: "center !important",
		justifyContent: "center !important",
		pointerEvents: "none",
		zIndex: "9999 !important",
	},
}));

export default DashboardCategoryResultPopoverStyle;
